// AGC: QueryOnlyProvider - App root provider without wallet/injector
// AGC: Use this until blockchain wallets are enabled to avoid extension injector timeouts
// AGC: When ready for wallets, switch app entry to WalletProvider

import React, { ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // AGC: 5 minutes
      retry: 3,
      refetchOnWindowFocus: true,
      // AGC: offlineFirst — return cached data when offline, fetch when online
      // AGC: Prevents queries from hanging/erroring when starting in airplane mode
      networkMode: 'offlineFirst',
    },
    mutations: {
      // AGC: Mutations pause when offline, auto-resume when back online
      networkMode: 'offlineFirst',
    },
  },
})

export interface QueryOnlyProviderProps {
  children: ReactNode
}

/**
 * AGC: QueryOnlyProvider - TanStack Query only, no wallet/blockchain providers
 * AGC: Prevents wallet extension injector from being triggered until blockchain is used
 */
export const QueryOnlyProvider: React.FC<QueryOnlyProviderProps> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    {children}
  </QueryClientProvider>
)
